/* global ResizeObserver */
document.addEventListener('DOMContentLoaded', () => {
    const scalableSections = document.querySelectorAll('.scalable-section');

    scalableSections.forEach(section => {
        const scalableImg = section.querySelector('.sl-image-wrap');
        const detailWraps = section.querySelectorAll('.sl-detailwrap');

        if (!scalableImg) {return;}

        detailWraps.forEach(detail => {
            const list = detail.querySelector('.sl-list');
            const track = detail.querySelector('.scroll-indicator-track');
            const thumb = detail.querySelector('.scroll-indicator-thumb');

            if (!list) {return;}

            const setMaxHeight = () => {
                const parentHeight = scalableImg.offsetHeight + 5;
                list.style.maxHeight = parentHeight + 'px';
                updateThumb();
            };

            const updateThumb = () => {
                if (!track || !thumb) {return;}

                const scrollHeight = list.scrollHeight;
                const visibleHeight = list.clientHeight;

                if (scrollHeight <= visibleHeight) {
                    track.style.display = 'none';
                    return;
                }

                track.style.display = 'block';

                const trackHeight = track.clientHeight;
                const scrollTop = list.scrollTop;

                let thumbHeight = (visibleHeight / scrollHeight) * trackHeight;
                thumbHeight = Math.max(thumbHeight, 40);

                const maxScroll = scrollHeight - visibleHeight;
                const maxThumbMove = trackHeight - thumbHeight;

                const thumbTop = maxScroll > 0
                    ? (scrollTop / maxScroll) * maxThumbMove
                    : 0;

                thumb.style.height = thumbHeight + 'px';
                thumb.style.transform = `translateY(${thumbTop}px)`;
            };

            // Scroll listener
            list.addEventListener('scroll', updateThumb);

            // Observe image height changes (better than window resize)
            const resizeObserver = new ResizeObserver(() => {
                setMaxHeight();
            });

            resizeObserver.observe(scalableImg);

            // Initial setup
            setMaxHeight();
        });
    });
});
